import { InjectionToken } from '@angular/core';

export const CORE_CONFIG = new InjectionToken<CoreConfig>('kp-core-config');

export interface CoreConfig {
  apis: {
    apiKonquestUrl: string;
    apiRegulatoryComplianceURL?: string;
    apiMyAccountUrl: string;
    apiMyAccountV2Url?: string;
    apiLearnAnalyticsUrl?: string;
    apiAluraIntegration?: string;
    apiKontentUrl?: string;
    certificateManager?: string;
    caixaApiGateway?: string;
    apiSisyphusUrl?: string;
    apiChatbotAnalytics?: string;
    apiCustomSectionsUrl?: string;
  };
  appId: string;
  production: boolean;
  applicationsApiBasePath?: string;
  scormWrapperUrl?: string;
}
